// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// const API_URL = `https://onlinecoursehost-prod.appspot.com`;

const API_URL = `https://api.onlinecoursehost.com`;

const isTestSubdomain = document.location.search?.includes("tenantId=AD18N9JOvzXBs6RJduO7CP8rKmH2");

const authDomain = isTestSubdomain ? "onlinecoursehost-prod.firebaseapp.com" : "auth.onlinecoursehost.com";

console.log(`environment.prod isTestSubdomain ${isTestSubdomain} authDomain ${authDomain}`);

export const environment = {
  production: true,
  test: false,
  useEmulators: false,
  domainName: "onlinecoursehost.com",
  platformCloudfrontDomain: "d8avu785lzlph.cloudfront.net",
  firebase: {
    apiKey: `AIzaSyAyRQSSmk_GPSGublhK1o-maKAOc3Srb5k`,
    authDomain,
    databaseURL: `https://onlinecoursehost-prod.firebaseio.com`,
    projectId: `onlinecoursehost-prod`,
    storageBucket: `onlinecoursehost-prod.appspot.com`,
    messagingSenderId: `856886270497`,
    appId: `1:856886270497:web:fc915dc187799f77a3e160`,
    measurementId: `G-M1M08EEVHP`
  },
  google: {
    googleAnalyticsTrackingId: "GTM-TWLVLL2J", // google analytics tracking Id for admin@onlinecoursehost.com
    googleAdsGlobalTrackingId: "AW-378395162" // admin@onlinecoursehost.com google Ads conversions tracking ID, to be installed in every page of the website
  },
  authenticationUrl: `https://login.onlinecoursehost.com/login-page`,
  stripe: {
    // this is platform Connect account Id https://dashboard.stripe.com/test/settings/connect, which is providing the hosting service to other tenant Stripe accounts
    stripeHostClientId: `ca_Gvq4QDeoVGeZ6ZhEVD54rigV2zkOiXgQ`,
    stripePublicKey: `pk_live_XzA4SNmBzT3XGfgM2mMkpIzO008maJqx45` // This is the public key needed by Checkout.js
  },
  paypal: {
    platformClientId: "Aegbhqmf6a_dLnoxc50-mhvtw7lbmy5os7uvvHGSmbj4ieH0t6ZLSL6L41s-hFziYS-uIUmuy7X3buqY"
  },
  rewardful: {
    platformAffiliateId: "98532a"
  },
  facebook: {
    platformPixelId: "501280424286480"
  },

  features: {
    partnerProgram:false,
    paypalIntegration:true,
    quizzes: false,
    drip: true
  },
  // REST API endpoints
  api: {
    purchaseCourseUrl: `${API_URL}/api/purchase-course`,
    purchaseBundleUrl: `${API_URL}/api/purchase-bundle`,
    customJwtUrl: `${API_URL}/api/custom-jwt`, // creates a custom authentication JWT for a given user. Used in the single-sign on solution for tenant domains
    stripeActivatePlanUrl: `${API_URL}/api/activate-plan`,
    stripeCancelPlanUrl: `${API_URL}/api/cancel-plan`,
    resourceAccessUrl: `${API_URL}/api/resource-access`, // load the file names only for which the user has access, which allows the user to for example play the video
    sendEmailUrl: `${API_URL}/api/send-email`,
    stripeConnectionUrl: `${API_URL}/api/stripe-connection`, // get the user credentials from Stripe and stores them in the DB
    stripeInitPricingPlansUrl: `${API_URL}/api/init-pricing-plans`,
    stripeUpdatePricingPLanUrl: `${API_URL}/api/update-pricing-plan`,
    stripeUpdateCardUrl: `${API_URL}/api/update-card`,
    fulfillFreeCouponUrl: `${API_URL}/api/fulfill-free-coupon`,
    newsletterUrl: `${API_URL}/api/newsletter`,
    downloadEmailsUrl: `${API_URL}/api/download-all-emails`,
    activateTeamMemberUrl: `${API_URL}/api/activate-team-member`,
    updateTeamSizeUrl: `${API_URL}/api/update-team-size`,
    createSubscriptionCouponUrl: `${API_URL}/api/create-subscription-coupon`,
    getStripeSettingsUrl: `${API_URL}/api/get-stripe-settings`,
    activateSubscriptionCouponUrl: `${API_URL}/api/activate-subscription-coupon`,
    updateInstructorPlanUrl: `${API_URL}/api/update-instructor-plan`,
    confirmPaypalPurchaseUrl: `${API_URL}/api/confirm-paypal-purchase`,
    getAvailableCurrenciesUrl: `${API_URL}/api/get-available-currencies`,
    purchaseInstructorLifetimePlanUrl: `${API_URL}/api/purchase-instructor-lifetime-plan`,
    activateMultiTierLifetimePlanUrl: `${API_URL}/api/activate-multi-tier-lifetime-plan`,
    createUserUrl: `${API_URL}/api/create-user`,
    activatePlatformLifetimeCouponUrl: `${API_URL}/api/activate-platform-lifetime-coupon`,
    sendPreviewEmailUrl: `${API_URL}/api/send-preview-email`,
    requestBulkEmailUrl: `${API_URL}/api/request-bulk-email`,
    sendBulkEmailUrl: `${API_URL}/api/send-bulk-email`,
    checkBulkEmailVerificationStatusUrl: `${API_URL}/api/check-bulk-email-verification`,
    startBulkEmailVerificationUrl: `${API_URL}/api/start-bulk-email-verification`,
    cancelBulkEmailVerificationUrl : `${API_URL}/api/cancel-bulk-email-verification`,
    deleteStudentAndEnrollmentUrl: `${API_URL}/api/delete-student-and-enrollment`,
    setUserPermissionsUrl: `${API_URL}/api/set-admin-permissions`,
    activateCustomDomainCertificateUrl: `${API_URL}/api/activate-custom-domain-certificate`,
    deleteCustomDomainCertificateUrl: `${API_URL}/api/delete-custom-domain-certificate`,
    createCustomDomainUrl: `${API_URL}/api/create-custom-domain`,
    checkCustomDomainUrl: `${API_URL}/api/check-custom-domain`,
    resetCustomDomainUrl: `${API_URL}/api/reset-custom-domain`,
    createStripeCustomerPortalSession: `${API_URL}/api/create-customer-portal-session`,
    aiChatBotUrl: `${API_URL}/api/ai-chat`,
    startAiChatSessionUrl: `${API_URL}/api/start-ai-chat-session`,
    continueAiChatSessionUrl: `${API_URL}/api/continue-ai-chat-session`,
    downloadStudentsUrl: `${API_URL}/api/download-students`,
    deleteMultipleStudentsUrl: `${API_URL}/api/delete-multiple-students`,
    exportAffiliatePayoutCsv: `${API_URL}/api/extract-affiliate-commissions-csv`,
    purchaseLifetimeStorageUrl: `${API_URL}/api/purchase-lifetime-storage`,
  },
  algolia: {
    app_id: `MLN7U6GUV2`,
    search_key: `c823492fdf909629bd74a297babf9be9`
  }
};
